<template>

  <Loader v-if="loader" />
  <div class="page">
    
    <accordion :multiple="true" :activeIndex="[0]" >

      <accordion-tab>
        <template #header>
          <span>Contratti abilitati all'emissione del modulo RID</span>&nbsp;<span>({{ data_.contrattiWithIban.length }})</span>
        </template>

        <div class="py-3" v-if="data_.contrattiWithNoIban.length > 0">
          <Checkbox  v-model="checked" :binary="true" @change="toggleCtrsWithNoIban()"/>
          Abilita/Disabilita i contratti senza iban
        </div>

        <data-table 
          :value="data_.contrattiWithIban" 

          responsiveLayout="scroll"

          v-model:selection="selectedContracts" 
          dataKey="id"

          rowGroupMode="rowspan" 
          groupRowsBy="iban"

          sortMode="multiple" 
        >
          <column selectionMode="multiple" headerStyle="width: 3em"></column>
          <column field="code" header="Contratto"></column>
          <column field="ragsoc" header="Cliente" sortable></column>
          <column field="codfis" header="Codice Fiscale"></column>
          <column field="piva" header="Partita IVA"></column>
          <column field="iban" header="IBAN"></column>
          <column field="pods" header="POD"></column>
          <column field="pdrs" header="PDR"></column>
        </data-table>

        <div v-if="selectedContracts.length > 0" class="p-d-flex p-p-3 card">
          <prime-button label="Scarica PDF" icon="pi pi-file-pdf" class="mb-auto ml-2" @click="scaricaModuloRidPdf()" />
          <prime-button label="Genera PDF" icon="pi pi-file-pdf" class="mb-auto ml-2" @click="generaModuloRidPDF()" />
          <prime-button label="Visualizza PDF" icon="pi pi-eye" class="mb-auto ml-2" @click="anteprimaModuloRidPDF()" />
        </div>

      </accordion-tab>

      <accordion-tab>
        <template #header>
          <span>Contratti attivi senza IBAN</span>&nbsp;<span>({{ data_.contrattiWithNoIban.length }})</span>
        </template>

        <data-table 
          :value="data_.contrattiWithNoIban" 

          responsiveLayout="scroll"

          sortMode="multiple" 
        >
          <column field="code" header="Contratto">
            <template #body="{ data }">
              <router-link
                :to="`/ask/contratti/vendita/${data.id}/dettagli`"
                custom
                v-slot="{ href }"
              >
                <prime-button 
                  :label="`${data.code}`" 
                  class="p-button-info p-button-text"
                  @click="navigateToTab(href)" 
                />
              </router-link>
            </template>
          </column>
          <column field="ragsoc" header="Cliente" sortable></column>
          <column field="codfis" header="Codice Fiscale"></column>
          <column field="piva" header="Partita IVA"></column>
          <column field="pods" header="POD"></column>
          <column field="pdrs" header="PDR"></column>
        </data-table>

      </accordion-tab>

      <accordion-tab>
        <template #header>
          <span>Contratti inattivi</span>&nbsp;<span>({{ data_.contrattiInattivi.length }})</span>
        </template>

        <data-table 
          :value="data_.contrattiInattivi" 

          responsiveLayout="scroll"

          sortMode="multiple" 
        >
          <column field="code" header="Contratto"></column>
          <column field="ragsoc" header="Cliente" sortable></column>
          <column field="codfis" header="Codice Fiscale"></column>
          <column field="piva" header="Partita IVA"></column>
        </data-table>

      </accordion-tab>

    </accordion>
    
  </div>
</template>

<script>
import Service from '@/services/ask-management/modulo-rid-contratti-vendita-service.js'
import UtilityService from '@/services/ask-management/utility-service'
import Loader from '@/components/Loader.vue'

import PrimeButton from 'primevue/button'

export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  
  components: {
    PrimeButton,
    Loader
  },

  data() {
    return {
      page:{
        name: 'contratti-vendita-modulo-rid',
      },
      loader: false,

      checked: false,
      selectedContracts: [],
      typeRid: -1,
      moduloRidId: null,

      data_: {
        contrattiIds: this.data,
        contrattiInattivi: [],
        contrattiWithIban: [],
        contrattiWithNoIban: [],
        tipiRid: []
      },
    }
  },

  async created(){
    this.service = new Service(this.$http, this.$eventBus)

    this.loader = true 
    Promise.all([
      this.getContrattiWithIban(), 
      this.getContrattiWithNoIban(), 
      this.getContrattiInattivi(), 
    ]).then(() => {
      this.loader = false 
    })


    this.utilityService = new UtilityService(this.$http, this.$eventBus)
    this.getTipiRid()
  },

  methods:{
    onCancelButton(){
      this._reset()

      this.$eventBus.emit('dialog-return-cancel-button', {})
    },

    ////

    onGetPdfButton(view){
      this.loader = true
      this.service.downloadModuloRidZip(
        view,
        {
          'contratto_vendita.ids': this.selectedContracts.map((el) => el.id)
        }
      ).finally(()=>{
        this.loader = false
      })
    },


    anteprimaModuloRidPDF(){
      this.loader = true
      this.service.anteprimaModuloRid(
        {
          'contratto_vendita.ids': this.selectedContracts.map((el) => el.id)
        }
      )
      .then((res)=> {
        // const path = URL.createObjectURL(res.items);
        // window.open(path);
        // Supponiamo che tu abbia ricevuto i contenuti dei file PDF come dati JSON dal backend
        let pdfContents = res.items;
        pdfContents.forEach(pdfContent => {
          const decodedData = Uint8Array.from(atob(pdfContent), c => c.charCodeAt(0));
          const blob = new Blob([decodedData], { type: 'application/pdf' });
          const pdfUrl = URL.createObjectURL(blob);
          // Apri l'URL di dati in una nuova finestra del browser
          window.open(pdfUrl);
        });
      })
      .finally(()=>{
        this.loader = false
      })
    },
    scaricaModuloRidPdf(){
      this.loader = true
      this.service.scaricaModuloRid(
        {
          'contratto_vendita.ids': this.selectedContracts.map((el) => el.id)
        }
      ).finally(()=>{
        this.loader = false
      })
    },

    generaModuloRidPDF(){
      let metod = true
      this.loader = true
      this.service.generaModuloRid(
        metod,
        {
          'contratto_vendita.ids': this.selectedContracts.map((el) => el.id)
        }
      ).finally(()=>{
        this.loader = false
      })
    },




    // onGetPdfButton(metod){
    //   this.loader = true
    //   this.service.downloadModuloRidZip(
    //     metod,
    //     {
    //       'contratto_vendita.ids': this.selectedContracts.map((el) => el.id)
    //     }
    //   ).finally(()=>{
    //     this.loader = false
    //   })
    // },


    // onSendRequestSignPdfButton(){
    //     this.loader = true
    //     // this.service.downloadModuloRidZip(
    //     //   this.typeRid,
    //     //   {
    //     //     'contratto_vendita.ids': this.selectedContracts.map((el) => el.id)
    //     //   }
    //     // ).finally(()=>{
    //     //   this.loader = false
    //     // })
      
    //     this.loader = true
    //     this.service.signPdfRid(this.data.id)
    //   .then((res)=> {
    //     if (res.items) {
    //       console.log(res.items);
    //       // toast.add({severity:'success', summary:'Successo', detail: 'Email per firmare il contratto inviata'});
    //     }
    //   })
    //   .finally(()=> {
    //     this.loader = false
    //   })
    // },



    ////

    _reset(){
      this.typeRid = -1
      this.selectedContracts = []

      this.data_.contrattiIds = []

      this.data_.contrattiInattivi = []
      this.data_.contrattiWithIban = []
      this.data_.contrattiWithNoIban = []
      this.data_.tipiRid = []
    },

    navigateToTab(href){
      window.open(href, '_blank')
    },

    async getContrattiWithIban(){
      await this.service.getContrattiWithIban({
        'contratto_vendita.ids': this.data_.contrattiIds
      }).then((res) => {
        this.data_.contrattiWithIban = res.items
      })
    },

    async getContrattiInattivi(){
      await this.service.getContrattiInattivi({
        'contratto_vendita.ids': this.data_.contrattiIds
      }).then((res) => {
        this.data_.contrattiInattivi = res.items
      })
    },

    
    async getContrattiWithNoIban(){
      await this.service.getContrattiWithNoIban({
        'contratto_vendita.ids': this.data_.contrattiIds
      }).then((res) => {
        this.data_.contrattiWithNoIban = res.items
      })
    },

    getTipiRid(){
      this.utilityService.getTipiRid().then((res) => {
        res.items.unshift({
          id: -1,
          name: 'Nessuno'
        })

        this.data_.tipiRid = res.items
      })
    },
    toggleCtrsWithNoIban(){
      if (this.checked) {
         this.data_.contrattiWithIban = [...new Set([...this.data_.contrattiWithIban, ...this.data_.contrattiWithNoIban])];
      } else {
        this.data_.contrattiWithIban = this.data_.contrattiWithIban.filter((el) => el.iban)
      }
    }
  },

}
</script>

<style scoped>
  
</style>
